export const checksums = {
  "pages": "v3.3.0--mgLOf3hamJsEwRa81uzPyx8xajsUuDr4GtUoSkpCPfQ",
  "snippets": "v3.3.0--DLNn1JXHahfxdO696gnGrnNDiHt6A4Qh_uFU-PN2duc"
}
export const checksumsStructure = {
  "pages": "yP0ovBcwWO1SiMUC-s-xucHpdEo-px60ObyL7NuMbQg",
  "snippets": "F4JcZcw2_RsZH1nskU8KINTvK8c_79GqwaYixuAs_-M"
}

export const tables = {
  "pages": "_content_pages",
  "snippets": "_content_snippets",
  "info": "_content_info"
}

export default {
  "pages": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json",
      "introduction": "boolean",
      "headline": "string",
      "icon": "string",
      "wistiaId": "string"
    }
  },
  "snippets": {
    "type": "page",
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "path": "string",
      "title": "string",
      "description": "string",
      "seo": "json",
      "body": "json",
      "navigation": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}